import { render, staticRenderFns } from "./BackgroundContainer.vue?vue&type=template&id=754b2865&scoped=true&"
import script from "./BackgroundContainer.vue?vue&type=script&lang=ts&"
export * from "./BackgroundContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundContainer.vue?vue&type=style&index=0&id=754b2865&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b2865",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
